// _getCurrentPositionAff :: Options -> EffectFnAff LatLng
export function _getCurrentPositionAff(options) {
  return function (onError, onSuccess) {
    if (!navigator.geolocation) {
      onError("Geolocation unavailable");
      return;
    }
    try {
      navigator.geolocation.getCurrentPosition(
        function (pos) {
          onSuccess(pos.coords);
        },
        onError,
        options
      );
    } catch (error) {
      onError(error);
    }
    return function (cancelError, onCancelerError, onCancelerSuccess) {
      // cancel is not possible
      onCancelerSuccess();
    };
  };
}
